import { z } from 'zod/v4';
import { createDefinitionSchema } from '../../utils/helpers';

export const activeAlertsPanelDefinitionSchema = createDefinitionSchema('ChronoActiveAlertsList', z.object({}));
